import Image from "components/Image"
import Container from "../../components/Container"
import Subtitle from "../../components/Subtitle"
import Title from "../../components/Title"
import tracking from "../../trackings"

import "./bankslip.scss"
import Link from "../../components/Link"
import { navigate } from "gatsby"

const Bankslip = () => {
  const onButtonClick = () => {
    tracking.accessBankslipClick()
    navigate("/registro")
  }

  return (
    <section className="landing-bankslip">
      <Container className="landing-bankslip__container">
        <div className="landing-bankslip__content">
          <Title className="landing-bankslip__title">
            Acesse sua 2ª via de boleto
          </Title>

          <Subtitle>
            Emita boletos da sua renegociação e confira detalhes sobre
            pagamentos.
          </Subtitle>

          <Link onClick={onButtonClick} className="landing-bankslip__desk-link">
            Acessar boleto
          </Link>
        </div>

        <Image
          src="/images/landing/bankslip.png"
          className="landing-bankslip__image"
          alt="Celular com aplicativo do Itaú aberto na tela de seleção de método de pagamento"
        />

        <Link onClick={onButtonClick} className="landing-bankslip__mobile-link">
          Acessar boleto
        </Link>
      </Container>
    </section>
  )
}

export default Bankslip
